// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4410f03f","952":"4a837601"}[chunkId] + ".chunk.js";
};